import { Component } from '@angular/core';

/**
 * KVKK md.11 ilgili kişi hakları listesi — kanun metnidir.
 *
 * Hem Aydınlatma Metni'nde hem Çerez Bilgilendirme Metni'nde birebir aynı
 * görünmek zorundadır; iki yerde ayrı ayrı tutulursa metinler zamanla
 * birbirinden ayrışır. Bileşen yalnızca listeyi render eder — başlığı
 * (ve o metindeki bölüm numarasını) her sayfa kendisi verir.
 */
@Component({
  selector: 'app-kvkk-haklariniz',
  templateUrl: './kvkk-haklariniz.component.html'
})
export class KvkkHaklarinizComponent {}
